module.exports = __webpack_public_path__ + "img/estate-land.e20dc91a.webp";